import { API_USER_URL } from "@/env";
import { message } from "antd";

function getUserIdFromLocalStorage() {
    const userData = localStorage.getItem('user');
    if (userData) {
        const user = JSON.parse(userData);
        return user.id;
    }
    return null;
}

async function getUserProfile() {
    const userId = getUserIdFromLocalStorage();
    if (!userId) {
        message.error('Người dùng không hợp lệ!');
        return;
    }
    const res = await fetch(API_USER_URL + `/api/v1/be/users/${userId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
    });

    const data = await res.json();

    if (!res.ok) {
        message.error('Lấy thông tin thất bại!');
    }

    return data.data;
}

async function updateUserProfile(data: any) {
    const userId = getUserIdFromLocalStorage();
    if (!userId) {
        message.error('Người dùng không hợp lệ!');
        return;
    }
    const res = await fetch(API_USER_URL + `/api/v1/be/users/${userId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(data),
    });

    const resData = await res.json();
    
    if (!res.ok) {
        message.error('Cập nhật thất bại!');
    }
    else {
        if (!resData.data) {
            message.error('Cập nhật thất bại!');
        }

        localStorage.setItem('user', JSON.stringify(resData.data));
        message.success('Cập nhật thành công!');
    }
    return resData.data;
}


export {
    getUserProfile,
    updateUserProfile
}